var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-not-found ta-center"},[_c('img',{staticClass:"img",attrs:{"src":require("./../../assets/img/page-not-found.png")}}),_c('h5',{staticClass:"text-subtitle"},[_vm._v("Página não encontrada.")]),_c('p',{staticClass:"text-info"},[_vm._v("Por favor, verifique o endereço"),_c('br'),_vm._v("digitado e tente novamente.")])])
}]

export { render, staticRenderFns }